<div [ngClass]="class">
  @if(hasDropDown){
  <div class="col my-2">
    <app-custom-drop-down
      [parentForm]="parentForm"
      controlName="value"
      placeholder="Sélectionnez votre choix"
      [options]="options"
      [required]="true"
      [simpleDropDown]="true"
    ></app-custom-drop-down>
  </div>
  } @if(hasSecDropDown && parentForm.get('value')?.value == 2){
  <div class="col my-2">
    <app-custom-drop-down
      [parentForm]="secParentForm"
      controlName="value"
      placeholder="Sélectionnez votre choix"
      [options]="options2"
      [required]="true"
      [simpleDropDown]="true"
    ></app-custom-drop-down>
  </div>
  }
  <input
    type="file"
    class="file-input"
    id="my-file"
    (change)="onFileSelected($event)"
    [multiple]="multiple"
    #fileUpload
  />
  <div *ngIf="label" class="fs-13 fw-6 text-neutral-dark mb-px-4">
    {{ label }}<span class="required" *ngIf="required"> *</span>
  </div>
  @if(label == "Carte d’identité ou passeport" && parentForm.get('value')?.value
  == 1 && !files.length){
  <div class="required fs-13">
    Télécharger Votre Carte d’identité Recto/Verso
  </div>
  } @if (!files.length) {
  <div class="upload-file cursor-pointer" (click)="fileUpload.click()">
    <svg-icon src="assets/icons/file.svg"></svg-icon>
    <div class="fs-13 text-neutral-dark-grey ml-px-16">
      Glissez vos documents ici ou
      <span class="text-accent-action">Parcourir vos fichiers</span>
    </div>
  </div>
  } @else { @for(item of files; track item?.file?.name; let i = $index) {
  <div class="uploaded-file" [ngClass]="{ 'mt-4': files.length && multiple }">
    <div
      class="d-flex justify-content-between align-items-center"
      [ngClass]="{ 'mt-px-10': !$first }"
    >
      <div class="d-flex align-items-center">
        <svg-icon
          src="assets/icons/{{ getType(item?.file?.type) }}.svg"
        ></svg-icon>
        <div class="text-neutral-dark fs-13 ml-px-8">
          {{ item?.file?.name }}
        </div>
      </div>

      <div>
        <svg-icon
          src="assets/icons/extand.svg"
          class="mr-px-8 cursor-pointer"
          *ngIf="item?.url && item?.file"
          (click)="openDisplayPdf(item?.url, item?.file)"
        ></svg-icon>
        @if(isDeletable){
        <svg-icon
          src="assets/icons/close-circle-grey.svg"
          class="cursor-pointer"
          (click)="delete(i)"
        ></svg-icon>
        }
      </div>
    </div>
  </div>
  }
  <div
    class="upload-file cursor-pointer mt-3"
    *ngIf="multiple"
    (click)="fileUpload.click()"
  >
    <svg-icon src="assets/icons/file.svg"></svg-icon>
    <div class="fs-13 text-neutral-dark-grey ml-px-16">
      Glissez vos documents ici ou
      <span class="text-accent-action">Parcourir vos fichiers</span>
    </div>
  </div>
  }
  <div class="required fs-13">{{ errorMsg }}</div>
</div>
